const entryFeeChoices = [0, 50, 100, 150, 200, 250, 500, 1000];

export default entryFeeChoices;
